const SINGLE_PROJECT_ROUTES = ['/dashboard', '/variation-assessments', '/progress-claim', '/pcg-report', '/project-details', '/project-setup']

export const isSelectionRouteDisabled = (path: string, isPortfolio: boolean) => {
  if (path === '/portfolio-overview' || path.startsWith('/portfolio-overview/')) return !isPortfolio
  return isPortfolio && SINGLE_PROJECT_ROUTES.some((route) => path === route || path.startsWith(`${route}/`))
}

export const singleProjectLandingRoute = (pageNames: string[]) => {
  const routes = [
    ['Dashboard', '/dashboard'], ['Variations', '/variation-assessments'], ['ProgressClaims', '/progress-claim'],
    ['PCG', '/pcg-report'], ['ProjectDetails', '/project-details'], ['ProjectSetup', '/project-setup'],
  ]
  return routes.find(([module]) => pageNames.some((name) => name === module || name.startsWith(`${module}.`)))?.[1] ?? '/notifications'
}
